var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", [
        _c("span", [
          _vm._v(
            " " +
              _vm._s(_vm.$t("receivablePayable.total")) +
              _vm._s(_vm.$t("receivablePayable.totalCount")) +
              " "
          ),
          _c("span", { staticStyle: { color: "red" } }, [
            _vm._v(_vm._s(_vm.params.totalCount || 0)),
          ]),
          _vm._v(
            " " +
              _vm._s(_vm.$t("receivablePayable.unit")) +
              _vm._s(_vm.$t("receivablePayable.data")) +
              ", " +
              _vm._s(_vm.$t("receivablePayable.currentReview")) +
              " "
          ),
          _c("span", { staticStyle: { color: "red" } }, [
            _vm._v(_vm._s(_vm.params.unPaidCount || 0)),
          ]),
          _vm._v(
            " " +
              _vm._s(_vm.$t("receivablePayable.unit")) +
              _vm._s(_vm.$t("receivablePayable.unreconciledData")) +
              " "
          ),
        ]),
      ]),
      _c(
        "el-form",
        {
          ref: "examineForm",
          attrs: { size: "small", model: _vm.examineForm },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("receivablePayable.examine") + "：",
                prop: "examine",
                rules: {
                  required: true,
                  message: _vm.$t("basicData.CannotBeEmpty"),
                  trigger: ["blur", "change"],
                },
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.examineForm.examine,
                    callback: function ($$v) {
                      _vm.$set(_vm.examineForm, "examine", $$v)
                    },
                    expression: "examineForm.examine",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "5px" } },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "receivablePayable.PassMultipleDataMergingToGenerateOneReceipt"
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "5px" } },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "receivablePayable.GenerateMultipleReceiptsThrough"
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v(_vm._s(_vm.$t("receivablePayable.DoesNotPass"))),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("receivablePayable.remark") + "：",
                prop: "remark",
                rules: {
                  required: _vm.examineForm.examine === 2,
                  message: _vm.$t("basicData.CannotBeEmpty"),
                  trigger: ["blur", "change"],
                },
              },
            },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 6 },
                model: {
                  value: _vm.examineForm.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.examineForm, "remark", $$v)
                  },
                  expression: "examineForm.remark",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticStyle: { "text-align": "end" } },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.submit },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.determine")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }